export function addDispose(that: any, cb: () => any, deactivated = false) {
  that.$once('hook:beforeDestroy', cb)
  if (deactivated) {
    that.$once('hook:deactivated', cb)
  }
}
